import { Button, Form, Input } from "antd";

export function LoginForm({ form, loading, onSubmit }) {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => onSubmit?.(values)}
      autoComplete="off"
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email!" },
          { type: "email", message: "Email không hợp lệ!" },
        ]}
      >
        <Input placeholder="Nhập email" size="large" />
      </Form.Item>

      <Form.Item
        label="Mật khẩu"
        name="password"
        size="large"
        rules={[
          { required: true, message: "Vui lòng nhập mật khẩu!" },
          {
            pattern: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
            message:
              "Mật khẩu phải có ít nhất 8 ký tự, bao gồm 1 chữ hoa và 1 số!",
          },
        ]}
      >
        <Input.Password size="large" placeholder="Nhập mật khẩu" />
      </Form.Item>

      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
          block
        >
          Đăng nhập
        </Button>
      </Form.Item>
    </Form>
  );
}
